exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Youtube__wrapper {\n  width: 100%;\n  height: 0;\n  position: relative;\n  padding-bottom: 56.25%;\n}\n.Youtube__player {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

